export default __webpack_public_path__ + "static/media/back.c38541a5.svg";